import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=30665deb&scoped=true"
import script from "./addClassify.vue?vue&type=script&lang=js"
export * from "./addClassify.vue?vue&type=script&lang=js"
import style0 from "./addClassify.vue?vue&type=style&index=0&id=30665deb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30665deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30665deb')) {
      api.createRecord('30665deb', component.options)
    } else {
      api.reload('30665deb', component.options)
    }
    module.hot.accept("./addClassify.vue?vue&type=template&id=30665deb&scoped=true", function () {
      api.rerender('30665deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/components/addClassify.vue"
export default component.exports